import { styled } from "@mui/system";

/**
 * Error message container styling
 * @type {import('@mui/system').StyledComponent}
 */
export const ErrorContainer = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: "12px",
  lineHeight: "16px",
  color: "#ea2925",
  gap: "6px"
}));

/**
 * Error link styling for try again text
 * @type {import('@mui/system').StyledComponent}
 */
export const ErrorLink = styled("span")(({ theme }) => ({
  textDecoration: "underline",
  marginLeft: 4,
  cursor: "pointer"
}));
